import { render, staticRenderFns } from "./ProfileSteps.vue?vue&type=template&id=137453e2&scoped=true"
import script from "./ProfileSteps.vue?vue&type=script&lang=js"
export * from "./ProfileSteps.vue?vue&type=script&lang=js"
import style0 from "./ProfileSteps.vue?vue&type=style&index=0&id=137453e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137453e2",
  null
  
)

export default component.exports